import clsx from 'clsx';
import { baseButtonClass } from '../index';
import { RemoteButton } from '../../../../hooks/useRemote';

interface Props {
  buttons: RemoteButton[];
  onClick(position: number): void;
}

export const AppKeys = ({ buttons, onClick }: Props) => {
  const getButton = (position: number) =>
    buttons.find((button) => button.order === position);

  const handlePress = (position: number) => {
    const button = getButton(position);
    if (button === undefined) return undefined;
    return onClick(button.id);
  };

  return (
    <div
      className={clsx('col-span-full grid grid-cols-3 gap-4 py-2', {
        'gap-2': window.devicePixelRatio > 1,
        'gap-4': window.devicePixelRatio <= 1,
      })}
    >
      <button
        disabled={Boolean(getButton(1)) === false}
        className={clsx(baseButtonClass, '!text-white h-5', {
          'scale-75': window.devicePixelRatio > 1,
        })}
        style={{ background: '#F5AC1F' }}
        onClick={() => handlePress(1)}
        onTouchEnd={() => handlePress(1)}
      >
        A
      </button>
      <button
        disabled={Boolean(getButton(2)) === false}
        className={clsx(baseButtonClass, '!text-white h-5', {
          'scale-75': window.devicePixelRatio > 1,
        })}
        style={{ background: '#2346FF' }}
        onClick={() => handlePress(2)}
        onTouchEnd={() => handlePress(2)}
      >
        B
      </button>
      <button
        disabled={Boolean(getButton(3)) === false}
        className={clsx(baseButtonClass, '!text-white h-5', {
          'scale-75': window.devicePixelRatio > 1,
        })}
        style={{ background: '#FA2330' }}
        onClick={() => handlePress(3)}
        onTouchEnd={() => handlePress(3)}
      >
        C
      </button>
    </div>
  );
};
